export const minimumSession =
  parseInt(window.sessions.minimum_session_time) || 1;
export const maximumSession =
  parseInt(window.sessions.maximum_session_time) || 10;
export const sessionQuestionTimer = parseInt(window.timer.countdown_timer);
export const standardSessionTime =
  (maximumSession - minimumSession) / 2 + minimumSession;
